/* ============
 * State of formalities module
 * ============
 *
 * The initial state of the formalities module.
 */

export default {
  onboarding: 1,
  possibility: null
}



// WEBPACK FOOTER //
// ./src/store/modules/loans/state.js